import React from "react";
import { PageContainer, PageContent, PageHeaders } from "../../components/Layout";
import Form from "./Form";

const NotifyNew = () => {
  const action = ["create"];

  return (
    <PageContainer>
      <PageHeaders title="Мэдэгдэл нэмэх" />
      <PageContent>
        <Form action={action} />
      </PageContent>
    </PageContainer>
  );
};

export default NotifyNew;